// What Đề xuất lists for one period: the lesson its teaching plan names, never the whole tree.
// Import-free apart from types, so node --test can load it.

import type { IztContentNode } from '../api/types';

type ContentUnit = IztContentNode['sections'][number]['units'][number];

export interface PeriodPlan {
  unitId?: string;
  name?: string;
  courseId?: string;
}

export interface PeriodSuggestion {
  unit: ContentUnit;
  courseId?: string;
}

/** The planned unit, resolved in the Kho bài tree for its type; a unit the tree lacks still opens by id. */
export function periodSuggestions(tree: IztContentNode[], plan: PeriodPlan): PeriodSuggestion[] {
  const unitId = plan.unitId ? String(plan.unitId) : '';
  if (!unitId) return [];
  const hits: PeriodSuggestion[] = [];
  tree.forEach((course) => course.sections.forEach((section) => section.units.forEach((unit) => {
    if (unit.id === unitId) hits.push({ unit, courseId: course.id });
  })));
  // the plan's course wins when the same unit sits in two courses
  const preferred = hits.filter((hit) => hit.courseId === plan.courseId);
  if (hits.length > 0) return [preferred.length > 0 ? preferred[0] : hits[0]];
  return [{ unit: { id: unitId, name: plan.name || 'Bài giảng của tiết này', type: null, homeworkQuestion: null }, courseId: plan.courseId }];
}
